<template>
  <div class="tutorial-list-bg">
    <div class="tutorial-block">
     <h3 @click="gotuTorialClass()">{{tutorialTitle}}</h3>
      <ul class="tutorial-list">
        <li v-for="(item,index) in tutorialList"><router-link :to='/contentPage/ + item.id'>{{item.title}}</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios'

    export default {
      name: "tutorialList",
      props:['url'],
      data() {
        return {
          tutorialTitle:'',
          tutorialList:[],
        }
      },
      created: function () {
        this.getTutorialList();
        // this.getTutorialData();
      },
      methods: {
        getTutorialList() {
          let _this = this;
          //获取新闻列表片数据
          axios.get(this.$store.state.apiBasePath + "/tutorial" + "/list?", {
            params: {
              type2: _this.url
            }
          }).then(function (res) {
            if (res.data.code === 200) {
              let resData = res.data.data;
              _this.tutorialList = resData.content;
              // 处理没有教程数据的情况
              if (resData.content && resData.content.length > 0) {
                _this.tutorialTitle=resData.content[0].type2;
              } else {
                // 根据url设置默认标题
                const titleMap = {
                  'seagate': 'Seagate',
                  'wd': 'WDC',
                  'hitachi': 'Hitachi',
                  'toshiba': 'Toshiba',
                  'samsung': 'Samsung',
                  'ssd_de': 'SSD+DE',
                  'other': 'Others'
                };
                _this.tutorialTitle = titleMap[_this.url] || _this.url;
              }
              // 像父组件传递教程列表数据
              _this.$emit('tutorialList', _this.tutorialList);
            }
          })
        },

        // 获取教程资料数据
        getTutorialData() {
          let lang = this.$store.state.lang
          let _this = this;
          let getUrl='';

          if (lang == 'zh') {
            getUrl = 'article/classificationUriChina?type=2&uri=' + this.url
          }else {
            getUrl = 'article/classificationUriEnglish?type=2&uri=' + this.url
          }
          axios.get(this.$store.state.apiBasePath + getUrl)
            .then(function (res) {
              let resData = res.data;
              if (resData.code == 200) {
                if (resData.data && resData.data.length > 0) {
                  _this.tutorialList = resData.data[0].tarticlesList;
                  if (lang == 'zh') {
                    _this.tutorialTitle = resData.data[0].name;
                  }else {
                    _this.tutorialTitle = resData.data[0].enName;
                  }
                } else {
                  // 根据url设置默认标题
                  const titleMap = {
                    'seagate': 'Seagate',
                    'wd': 'WDC',
                    'hitachi': 'Hitachi',
                    'toshiba': 'Toshiba',
                    'samsung': 'Samsung',
                    'ssd_de': 'SSD+DE',
                    'other': 'Others'
                  };
                  _this.tutorialTitle = titleMap[_this.url] || _this.url;
                  _this.tutorialList = [];
                }
                // 像父组件传递教程列表数据
                _this.$emit('tutorialList', _this.tutorialList);
              }
            })
        },
        // 跳转教程分类列表
        gotuTorialClass(){
          this.$router.push({path:'/tutorialClass',query: {url: this.url}})
        }
      },
    }
</script>

<style scoped lang="less">
  .tutorial-list-bg {
    display: flex;
    margin:10px 5px;
    justify-content: center;
    align-content: center;
    /*  stretch让盒子内的每个元素的高度都等于行高 */
    align-items: stretch;
  }
  .tutorial-block {
    background: #fff;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding:20px 0;
    display: flex;
    flex-direction: column;
  }
  .tutorial-block h3 {font:18px/36px "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif; margin:0 0 10px 0; padding-bottom:5px;
    font-weight: bold;  border-bottom: #e6e6e6 1px solid; color:#009e3b; cursor: pointer;position: relative }
  .tutorial-block h3:after {content: ''; width:60px; height: 3px; background: #009e3b; position: absolute;left: 0; bottom: -1px;}
  .tutorial-list {display: flex;flex-wrap: wrap; }
  .tutorial-list li {width:49%; font-size: 14px; line-height:36px; transition: all ease 0.3s; display: flex;justify-content: space-between;}
  .tutorial-list li a {text-decoration: none;color: #4c4c4c;position: relative; padding-left: 12px;}
  .tutorial-list li a:hover {color:#009e3b; cursor: pointer; transition: all ease 0.3s;}
  .tutorial-list li a:before {content: ""; position: absolute;width:4px; height: 4px; border-radius: 5px;background:#009e3b;display: block;
    top: 16px;
    left: 0;}


  @media screen and (max-width: 1024px) {
    .tutorial-list-bg {width: 100%;}
  }

  @media screen and (max-width: 767px) {
    .tutorial-list-bg {
      margin: 0;
      padding: 10px;
      box-sizing: border-box;
      .tutorial-list li {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tutorialList/tutorialList.vue